import React from "react";
import { MESSAGE_TAG_RESPONSE_TYPE } from "components/dashboard/Analyzer/enum";
import { Empty, Tag } from "components/ui";

const TDConversationsBody = ({ conversations, handleSelectTagResp }) => {
    return (
        <>
            <div className='analyzer-td__elements'>
                {conversations?.length ? (
                    <div className='analyzer-td__items'>
                        {conversations?.map((conversation, i) => (
                            <Tag
                                key={i}
                                name={conversation?.issue?.issueName}
                                onClick={(e) =>
                                    handleSelectTagResp(
                                        conversation,
                                        MESSAGE_TAG_RESPONSE_TYPE.CONVERSATION_RESPONSE
                                    )
                                }
                            />
                        ))}
                    </div>
                ) : (
                    <Empty text='No conversations created' />
                )}
            </div>
        </>
    );
};

export default TDConversationsBody;
